export default {
'_.lang.pl.text': 'polski',
'_.lang.en.text': 'english',
'_.lang.de.text': 'deutsch',
'_.lang.es.text': 'español',
'_.lang.it.text': 'italiano',
'_.lang.nl.text': 'nederlands',
'_.lang.ru.text': 'русский',
'_.lang.sk.text': 'slovenský',
'_.lang.cs.text': 'čeština',
'_.lang.uk.text': 'український',
'_.lang.ro.text': 'română',
'_.lang.fr.text': 'français',
'_.lang.hu.text': 'magyar',
'_.socialPoints': 'SocialPoints',
'_.cashPoints': 'CashPoints',
'_.pln': 'PLN',
'_.and': 'et',
'_.loadingSpinnerText': 'Veuillez patienter...',
'pageTimerMax.text': 'Vous serez automatiquement dirigé vers la page suivante après l\'expiration du temps imparti.',
'pageTimerMax.timeLeft': 'Temps restant',
'pageTimerMin.text': 'Il n\'y a pas de possibilité de passer à la page suivante avant l\'expiration du temps imparti.',
'pageTimerMin.timeLeft': 'Temps restant',
'pageTimerMin.allowNext': 'Vous pouvez continuer',
'survey.registerForm.label.email': 'E-mail',
'survey.registerForm.label.newsletter': 'Je souhaite recevoir la newsletter',
'survey.registerForm.label.regulations': 'J\'accepte la politique de confidentialité et les conditions générales',
'survey.registerForm.button.register': 'Inscrivez-vous',
'survey.registerForm.registered': 'Merci de vous être inscrit. Un e-mail contenant un lien d\'activation a été envoyé dans votre boîte aux lettres électronique.',
'survey.registerForm.cardHeader': 'Inscrivez-vous et recevez des points !',
'survey.registerForm.cardBody': 'Pour avoir répondu à l\'enquête, vous avez reçu',
'survey.registerForm.cardBody2': 'Les points vous seront crédités après l\'enregistrement de votre compte sur swpanel.co.uk. Saisissez votre adresse électronique et créez un compte sur swpanel.pl',
'survey.notProperDevice': 'Malheureusement, vous ne pouvez pas répondre à cette enquête sur cet appareil.',
'survey.properDevices': 'L\'enquête est accessible à partir des appareils suivants :',
'survey.device-phone': 'smartphone',
'survey.device-tablet': 'tablette',
'survey.device-desktop': 'ordinateur / portable',
'nextSurveys.header.seeAlso': 'Voir aussi les autres enquêtes',
'nextSurveys.button.fill': 'Remplir',
'question.noContent': 'Contenu de la question manquant',
'question.input.placeholder.typeYourAnswer': 'Saisissez votre réponse',

'question.conjoint.go': 'Cliquez sur le bouton "Suivant".',
'question.matrix.carousel.go': 'Cliquez sur le bouton "Suivant".',
'question.carousel.prevBtn': 'Déclaration précédente',
'question.carousel.nextBtn': 'Déclaration suivante',

'question.open.email.inputPlaceholder': 'Saisissez votre adresse électronique',
'question.open.email.emailVerify.sendCode': 'Envoyer le code de vérification',
'question.open.email.emailVerify.enderCode': 'Entrez le code que vous avez reçu',
'question.open.email.emailVerify.enderCode.inputPlaceholder': 'Entrez le code',
'question.open.email.emailVerify.confirm': 'Confirmer',
'question.open.email.emailVerify.codeIncorrect': 'Le code que vous avez saisi est incorrect',
'question.open.email.emailVerify.codeCorrect': 'L\'adresse e-mail a été correctement vérifiée',
'question.open.email.rodoText': 'The administrator of your personal data is SW Research Sp. z o.o. located at ul. J. Dąbrowskiego 64a, 02-561 Warszawa, Warsaw. For matters related to protecting your personal data and exercising your rights, you can contact the Data Protection Inspector at iod@swresearch.pl. Your personal data will be processed during the survey and accounting documentation for 5 years after the year the survey was completed. Your personal data will be processed for the purpose of participating in opinion surveys, analytical purposes to match our services to the needs of our clients, and for keeping accounting documentation (Article 6 (1) (b) of the GDPR(RODO), Article 6 (1) (f) of the GDPR(RODO), Article 6 (1) (c) of the GDPR(RODO) in connection with Article 86 § 1 of the Tax Ordinance).',

'footer.pauseButton.text': 'Pause remplissage',
'footer.buttonPrev.text': 'Annuler',
'footer.buttonClear.text': 'Effacer',
'footer.buttonNext.text': 'Suivant',
'footer.buttonEnd.text': 'Terminer',
'footer.buttonStart.text': 'Commencer l\'enquête',
'question.matrix.nextStatement': 'Déclaration suivante',
'question.matrix.previousStatement': 'Déclaration précédente',
};
